var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthorize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.795 2.797l1.414 1.414a1 1 0 010 1.415l-.668.666.665.665a1 1 0 010 1.414l-.708.707a1 1 0 01-1.414 0l-.664-.664-.564.563.71.71a1 1 0 010 1.414l-.708.708a1 1 0 01-1.414 0l-.71-.71-1.368 1.37a4 4 0 11-2.824-2.832l6.84-6.84a1 1 0 011.413 0zM6.5 10.5a3 3 0 103 3l-.005-.176-.025-.25-.03-.176a2.978 2.978 0 00-.08-.31l-.07-.193-.03-.071-.065-.143a3.012 3.012 0 00-1.42-1.397l-.212-.09c-.07-.026-.14-.05-.211-.071l-.242-.06-.162-.03a3.01 3.01 0 00-.273-.028L6.5 10.5zm10.002-5.582l-1.414-1.414-6.551 6.553a4.02 4.02 0 011.412 1.416l6.553-6.555zM13.15 9.685l-.707.707.71.71.706-.708-.709-.709zM15.834 7l-.707.707.664.665.707-.707-.664-.665z",
    fill: "#979797",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorize);
export default __webpack_public_path__ + "static/assets/authorize.978afe88.svg";
export { ForwardRef as ReactComponent };